module.exports = __webpack_public_path__ + "static/media/成单小店mp_icon.91eed000.png";